import { put , call, takeEvery} from 'redux-saga/effects';
import {setApprovalList , setApiStatus} from '../actions/ApprovalListActions';
import * as appConstants from '../constants/AppConstants';
import _ from 'lodash';
import ApprovalService from "../services/ApprovalService";
import LoggerService from "../services/LoggerService";
import store from "../stores/store";
import { ACTIVITY, ACTIVITY_CATEGORY } from '../constants/LogConstants';


export function* approvalListSaga(){

    yield takeEvery('GET_APPROVAL_LIST', function* (action){
        const { flowId } = action;
        yield call(approvalListActionSaga,flowId);
    })  
}

export function* approvalListActionSaga(flowId){
    let list = [];
    yield put(setApprovalList(list));
    yield put(setApiStatus(true));
    const userInfo = _.get(store.getState(), "AuthReducer.userInfo", {});
    try{
        const response = yield call(ApprovalService.getApprovalList,flowId);
        if (response.data) {
            let selectedTabApprovals = response.data;
            let pendingArray = _.filter(selectedTabApprovals, function (obj) {
                return obj.status === appConstants.PENDING
            });
            let nonPendingArray = _.filter(selectedTabApprovals, function (obj) {
                return obj.status !== appConstants.PENDING
            });
            let approvalList = [...pendingArray, ...nonPendingArray];
            //set approval List

            yield put(setApprovalList(approvalList));
            yield put(setApiStatus(false));
            const messageObject = {};
            messageObject.Message = "Fetched approval list successfully";
            messageObject.Functionality = ACTIVITY.FETCH_APPROVAL_LIST;
            messageObject.ActivityCategory = ACTIVITY_CATEGORY.FETCH;
            messageObject.Source_System = "Commerce";
            messageObject.Flow = "Get Approval List";
            messageObject.Screen = "CustomerApprovalPortal";
            messageObject.AgentId = "";
            messageObject.CustomerGuid = _.has(userInfo, "userId") ? userInfo.userId : "";
            messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
            messageObject.flowId = flowId;
            messageObject.Result = 'Success';
            LoggerService.saveSplunkLog(messageObject, 'info');
        }
    }catch(error){
        yield put(setApiStatus(false));
        yield put(setApprovalList([]));
        const messageObject = {};
        messageObject.Message = "Failed to fetch approval list";
        messageObject.Functionality = ACTIVITY.FETCH_APPROVAL_LIST;
        messageObject.ActivityCategory = ACTIVITY_CATEGORY.FETCH;
        messageObject.Source_System = "Commerce";
        messageObject.Flow = "Get Approval List";
        messageObject.Screen = "CustomerApprovalPortal";
        messageObject.AgentId = "";
        messageObject.CustomerGuid = _.has(userInfo, "userId") ? userInfo.userId : "";
        messageObject.countryCode = _.has(userInfo, "countryCode") ? userInfo.countryCode : "";
        messageObject.flowId = flowId;
        messageObject.errorMessage = error && error.message ? error.message : '';
        messageObject.Result = 'Failure';
        LoggerService.saveSplunkLog(messageObject, 'error');
    }

}

